import {toast} from 'sonner';
import {FastAPIServiceError, GuestTokenStorageHandler} from '@guestapp/sdk';
import {useGuestAccountTokenMutation} from 'hooks/auth/useGuestAccountTokenMutation';

type Props = {
  onSuccess?: () => void;
  onInvalid?: () => void;
  onError?: (error: FastAPIServiceError) => void;
};
export function useSignIn({onSuccess, onError, onInvalid}: Props) {
  const {mutate: signIn, isLoading} = useGuestAccountTokenMutation({
    onSuccess: async data => {
      GuestTokenStorageHandler.persistToken(data.access_token);
      onSuccess?.();
    },
    onError: error => {
      if (error.detail === 'Invalid credentials') {
        onInvalid?.();
      } else {
        console.error(error);
        toast.error(
          'An error occurred during sign-in. Please try again or contact support.',
        );
        onError?.(error);
      }
    },
  });

  return {signIn, isLoading};
}
